import React, { useEffect, useState } from "react";
import db from "../../db"

import EventCarousel from "../../components/Portfolio/Index/EventCarousel"

// reactstrap components


// core components


function SectionHeader() {

  // carousel
  const [carouselItems, setCarouselItems] = useState([])
  useEffect(() => db.EventCategories.listenAll(setCarouselItems), [])

  return (
    <>
      <div className="section-header cd-section" id="events">
        <div className="header-3">
          <EventCarousel carouselItems={carouselItems} />
        </div>
      </div>
    </>
  );
}

export default SectionHeader;
